import * as singleSpa from "single-spa"
import { NeoComponents } from "@forcepoint/platform-utilityui"
import { useState, useCallback } from "react"
import CollapsedMenuPopup from "./CollapsedMenuPopup"
import { isAppActive } from "./Sidebar.utils"
import { CollapsedSideBarProps, PopupPosition } from "./Sidebar.types"
import { APP_URL } from "@forcepoint/platform-coreui"

const CollapsedSideBar = ({ setIsExpandedSideBar, sideMenuData, activeAppCode }: CollapsedSideBarProps) => {

  const [isOpen, setIsOpen] = useState(null)

  const [position, setPosition] = useState<PopupPosition>({
    x: 0,
    y: 0,
    spaceAbove: 0,
    spaceBelow: 0,
    height: 0
  })

  const [hoveredMenu, setHoveredMenu] = useState(null)

  const setPopupPositions = useCallback((ev) => {
    const iconRect = ev.target.getBoundingClientRect()
    const spaceBelow = window.innerHeight - iconRect.bottom
    const spaceAbove = iconRect.top
    const { x, width, y, height } = iconRect
    const popupPos = {
      x: x + width + 10,
      y: y,
      spaceAbove,
      spaceBelow,
      height
    }
    setPosition(popupPos)
  }, [])

  return (
    <div className="collapsed-menu-container">
      <div
        className="menu-icons"
        onMouseLeave={() => {
          setHoveredMenu(null)
          setIsOpen(false)
        }}
      >
        {sideMenuData.map((application) => (
          <div
            className="collapse-menu-item"
            onKeyDown={() => { }}
            key={application?.applicationCode}
            data-always={application.applicationType === "external"}
            data-dark-html-tip-at="right"
            data-dark-html-tip={`<div class="collapse-menu-external-tooltip"><span>${application.applicationName}</span> <img class="sidemenu-link-icon white" src="/assets/images/linkIcon.svg" alt="open link in new tab" /></div>`}
            onMouseEnter={(ev) => {
              if (application?.menus?.length > 0) {
                setHoveredMenu(application)
                setIsOpen(true)
                setPopupPositions(ev)
              } else {
                setIsOpen(false)
              }
            }}
            onClick={() => {

              if (application.applicationType === "external") {
                const applicationUrl = APP_URL.endsWith(".eu")
                  ? application.iframeURL
                  : application.applicationURL
                window.open(applicationUrl, "_blank")
              } else if (application?.menus?.length < 1) {
                singleSpa.navigateToUrl(application.applicationURL)
              }
            }}
          >
            <div
              className={`collapsable-icon-box ${isAppActive(activeAppCode, application) ? "active-collapsable-icon-box" : ""}`}
            >
              {/* TODO: Remove NeoIcon and create a custom icon that works via a selection.json that will be stored in shell ui (works like neo icon) */}
              <NeoComponents.NeoIcon
                name={application?.productLogo || "applications"}
                size={20}
                fill={`${isAppActive(activeAppCode, application) ? "#00AF9A" : "#3D4E5C"}`}

              />
            </div>
          </div>
        ))}
        <CollapsedMenuPopup
          menuHeader={hoveredMenu?.applicationName?.toUpperCase()}
          parentApplicationCode={hoveredMenu?.applicationCode}
          hoveredMenu={hoveredMenu}
          isOpen={isOpen}
          position={position}
        />
      </div>
      <div
        className="right-icon"
        onKeyDown={() => { }}
        onClick={() => {
          sessionStorage.setItem("isExpanded", "true")
          setIsExpandedSideBar(true)
        }}
      >
        <img
          src="/assets/images/chevrons-right.svg"
          className="collapse-icon-collapsed"
          alt="right"
        />
      </div>
    </div>
  )
}

export default CollapsedSideBar
